import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12659b71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customizer-mini-grid" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "flex flex-col" }

import useCustomizer from '@/shared/product/customizer/useCustomizer';
import CustomizerMiniTab from '@/shared/product/customizer/ui/tabs/CustomizerMiniTab.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizerMini',
  setup(__props) {


const { tabs } = useCustomizer();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dl", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: tab.id
      }, [
        _createElementVNode("dt", _hoisted_2, _toDisplayString(tab.title), 1),
        _createElementVNode("dd", _hoisted_3, [
          _createVNode(CustomizerMiniTab, { tab: tab }, null, 8, ["tab"])
        ])
      ], 64))
    }), 128))
  ]))
}
}

})